var _defs, _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.57 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3d5629;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f36c25;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.64,38.23c-.23.05-.45.1-.66.15l-.25,1.62h8.96l-.5-3.38-7.55,1.61Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.57 33.58 10.54 33.37 15.55 32.3 14.81 27.31 9.5 28.44 8.68 33.77 9.57 33.58"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.17 23 13.49 18.45 11 18.58 10.2 23.85 14.17 23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.47,18.11c-.67-1.24-1.11-2.58-1.33-3.97l7.66-1.17c.08.51.24,1,.49,1.45l-6.82,3.68h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.73,16.74l-7.22-2.82c.19-.48.29-.99.31-1.52h0s7.75.22,7.75.22h0c-.05,1.43-.33,2.8-.84,4.11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.75,12.15L0,11.92h0c.05-1.42.33-2.79.83-4.1l7.22,2.81c-.19.48-.29.99-.31,1.51h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.77,11.58c-.08-.51-.24-1-.49-1.45l6.82-3.69c.67,1.24,1.12,2.58,1.34,3.97l-7.66,1.18h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.42,9.9L1.83,5.83c.74-1.2,1.67-2.25,2.77-3.13l4.85,6.04c-.41.32-.75.72-1.03,1.16h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.82,9.44c-.32-.41-.72-.75-1.16-1.03l4.07-6.59c1.2.74,2.25,1.67,3.13,2.76l-6.04,4.85h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.13,8.29L6.45,1.47c1.24-.67,2.58-1.12,3.97-1.33l1.17,7.66c-.51.08-1,.24-1.45.49h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.93,8.05c-.48-.18-.98-.29-1.5-.31h-.01S12.64,0,12.64,0h.01c1.41.04,2.78.32,4.08.83l-2.81,7.22h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.31,21.56c-.49-1.51-2.03-2.53-3.83-2.53l.41,2.81s.14-.03.33.09c.24.16.28.43.3.7.05.5-.37.99-.95,1.11l-6.77,1.44c-2.1.44-3.59,2.28-3.39,4.17.11,1.07.69,2,1.62,2.61.66.43,1.79.66,1.98.63,0,0,.48-2.72.4-2.72-.26,0-.5-.08-.7-.23-.25-.2-.38-.49-.35-.8.04-.44.42-.83.93-.94l6.91-1.47c1.12-.24,2.1-.9,2.69-1.82.61-.94.76-2.02.43-3.04h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.58,14.99c-.2-.95-2.04-1.2-2.99-1.2-.35,0-.67.03-.92.08-.59.12-1.14.45-1.52.9l-.95.21c-1.11.24-2.1.9-2.69,1.82-.6.94-.76,2.01-.43,3.04.48,1.51,1.71,2.51,3.51,2.51.09-.59.42-2.79.42-2.79-.09.02-.16.04-.24.04-.23,0-.29,0-.47-.13-.24-.16-.4-.41-.43-.68-.05-.5.37-.99.95-1.12l.99-.22c.33.14.71.22,1.09.22.19,0,.38-.02.56-.06.58-.12,1.4-.51,2.03-.95.57-.41,1.22-1.02,1.09-1.66h0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.33,20.08c-.23-.7-.26-1.42-.13-2.12l-2.51,2.01c.88,1.1,1.93,2.03,3.13,2.77l.55-.88c-.46-.48-.82-1.07-1.04-1.77Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.36,14.8s0,0,0,.01c.09.45.03,1.08-.62,1.8l4.22,5.25c1.1-.88,2.03-1.93,2.77-3.12l-6.37-3.94Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.92,30.59c-.49-1.51-2.03-2.53-3.83-2.53-.33,0-.94.1-1.26.16l.4,2.7c.09-.02.74-.13.84-.13.42,0,.78.2.96.51.15.27.16.59,0,.88-.15.29-.44.51-.79.58l-7.49,1.59-1.84.39c-.92.2-1.75.68-2.35,1.38-.1.11-.17.21-.23.29-.18.25-.33.52-.45.82-.04.11-.08.22-.11.35-.08.29-.13.59-.13.89v.41s.34-.22.34-.22c.57-.34,1.64-.84,3.51-1.24l9.33-1.98c1.12-.24,2.1-.9,2.69-1.82.61-.94.76-2.02.43-3.04h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ef7d9e2.svg";
export { ForwardRef as ReactComponent };